import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@/constants';
import { useBeforeRender } from '@/hooks/useBeforeRender';
import { PackageService, ProfileService, TransactionService } from '@/services';
import CustomerInfo from '@/components/Subscription/FormSub/CustomerInfo';
import Payment from '@/components/Subscription/FormSub/Payment';
import { alertSuccess } from '@/utils/notification';
import { Spin } from 'antd';

function FormSub({ data }) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [cusInfo, setCusInfo] = useState('');
  const [cusData, setCusData] = useState({
    customerFirstName: '',
    customerLastName: '',
    customerEmail: '',
    customerPhone: '',
    customerTaxNumber: '',
    customerCountry: { label: null, value: null },
    customerCity: { label: null, value: null },
    customerDistrict: { label: null, value: null },
    customerSubDistrict: { label: null, value: null },
    customerZipcode: '',
    customerAddress: '',
  });

  const fetchProfile = async () => {
    setLoading(true);
    const { success: okBilling, data: billing } =
      await ProfileService.getBillingInfo();
    const { success: okProfile, data: profile } =
      await ProfileService.getProfile();

    if (okBilling && okProfile) {
      const {
        defaultBillingCountry: _country,
        defaultBillingProvince: _province,
        defaultBillingDistrict: _district,
        defaultBillingWard: _ward,
      } = billing;
      setCusData({
        customerFirstName:
          billing?.defaultBillingFirstName || profile?.firstName,
        customerLastName: billing?.defaultBillingLastName || profile?.lastName,
        customerEmail: billing?.defaultBillingEmail || profile?.email,
        customerPhone: billing?.defaultBillingPhone || profile?.phoneNumber,
        customerTaxNumber: billing?.defaultBillingTaxNumber,
        customerCountry: {
          label: _country?.name,
          value: _country?.id,
        },
        customerCity: {
          label: _province?.name,
          value: _province?.id,
        },
        customerDistrict: {
          label: _district?.name,
          value: _district?.id,
        },
        customerSubDistrict: {
          label: _ward?.name,
          value: _ward?.id,
        },
        customerZipcode: billing?.defaultBillingZipcode,
        customerAddress: billing?.defaultBillingAddress,
      });
    }
    setLoading(false);
  };

  useBeforeRender(() => fetchProfile(), []);

  const onCheckout = (e) => {
    setCusData(e);
    setStep(2);
    setCusInfo(
      `${e.customerFirstName} ${e.customerLastName}, ${e.customerEmail}, ${e.customerPhone}`,
    );
  };

  const onBack = () => {
    setStep(1);
  };

  const onSubmit = async (file) => {
    const {
      success,
      data: { id },
    } = await PackageService.subscribe({
      ...cusData,
      packageId: data.id,
    });
    if (success) {
      if (file && id) {
        const res = await TransactionService.uploadSlip({ file, id });
        if (!res.success) {
          return;
        }
      }
      navigate(ROUTES.SUBSCRIPTIONS.INDEX);
      alertSuccess('CHECKOUT_SUCCESS');
    }
  };

  return (
    <div className="form-subscribe">
      <Spin spinning={loading}>
        {step === 1 && (
          <CustomerInfo
            data={data}
            onCheckout={onCheckout}
            formData={cusData}
          />
        )}
        {step === 2 && (
          <Payment
            data={data}
            cusInfo={cusInfo}
            onSubmit={onSubmit}
            onBack={onBack}
          />
        )}
      </Spin>
    </div>
  );
}

FormSub.propTypes = {
  data: PropTypes.object,
};

export default FormSub;
